
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/poll",
      function () {
        return require("private-next-pages/poll.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/poll"])
      });
    }
  